import BasePropertyView from 'BasePropertyView.js';
import eventBus         from 'EventBus.js';
import nameTemplate from 'report/properties/main/chart-scale.ejs';
import MainFormulaModal from 'common-views/MainFormulaModalView.js';

class MainChartScaleView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        //this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal );
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.delegateEvents();
        return this;
    }

}

export default MainChartScaleView;
